import React, { Component } from 'react';
import { getInvoiceInfo } from '../../../../API/FetchCall';
import PdfContainer from './PdfContainer';
import Doc from './DocService';

class TuitionCompare extends Component {

  constructor(props) {
    super(props);
    console.log('this.props', this.props);
    this.state = {
      compareData: this.props.viewData.compareData,
      ratingData: this.props.viewData.ratingData,
      date: this.props.viewData.date
    };
  }
  componentDidMount() {

  }
  createPdf = (html) => Doc.createPdf(html);


  render() {
    const { compareData, ratingData } = this.state;
    console.log('this.state.compareData re', compareData)
    let dataLen = compareData.length;
    let scl = dataLen > 0 ? compareData[0].name : '';
    return (

      <React.Fragment>
       <div class="row">
            <div class="hdr-logo-pdf"><img src="/assets/bewiseLogo.png" width="100%" /></div>
        </div>
        <div className="row invoice-container compare-container">
          <div className="back-drop">
            <h2>{`Confidential - Bewise prepared for ${scl.trim()}`}</h2>
            <div id="watermark"><img src="/assets/bewiseLogo.png" width="100%" /></div>
          </div>
          <div className='row ovrfls'>

            <div class="text-center padding45">
            <h2>Benchmark Compare View</h2>
            <p>Date : {this.state.date}</p>

            <div class="tableinner">
            <table className='styled-table'>
              <tr>
                <th>Name</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.name}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Sub Categories</th>
                {compareData.map((item, i) => {
                  return (
                    <td>{item.sub_categories}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Languages</th>
                {compareData.map((item, i) => {
                  return (
                    <td>{item.languages ? item.languages : 'NA'}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Board Of Education</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.curriculum}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Class Frequency</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.class_frequency ? item.class_frequency : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Class</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.class_range ? item.class_range : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Instruction Language</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.instruction_lang ? item.instruction_lang : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Learning Option</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.learning_opt ? item.learning_opt : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Timing</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.from_time.includes('NA') || item.to_time.includes('NA') ? 'NA' : `${item.from_time} - ${item.to_time}`}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Number of Classes /Month</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.noclass ? item.noclass : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Number Of Teacher</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.no_teacher ? item.no_teacher : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Established Year</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.est_year ? item.est_year : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Annual Avegrge Fee</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.avg_fee == 0 || item.avg_fee == 'NA' ? 'NA' : (<span>&#8377; {item.avg_fee}</span>)}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th class="separath" colSpan={1 + compareData.length}>Rating</th>
              </tr>
              <tr>
                <th>Covid19 responses</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.covid19}</td>
                  )
                })}
              </tr>
              <tr>
                <th>
                  Quality of Teacher (OR)
                  Counsellor (OR) Comfort with Trainer / Teacher
                </th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_teachers}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Quality of Teaching (OR) Counselling (OR) Method of Teaching / Coaching / Counselling</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_teaching}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Child Safety</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.child_safety}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Facilities & Connectivity (OR) Quality of Connectivity / Campus</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.facilities}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Ontime / Punctuality (OR) Punctuality</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.ontime_punctuality}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Ease of Interaction (OR) Information @ Website</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_intraction}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Overall Rating</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.overall_expirence}</td>
                  )
                })}
              </tr>
            </table>
            </div>
          </div>
          </div>
        </div>
       <div class="row">
            <div class="hdr-logo-pdf">© Copyright 2022 BeWise. All Rights Reserved</div>
        </div>
      </React.Fragment>

    );
  }
}

export default TuitionCompare;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmark/tuition_compare.jsx